var map = {
	"./icon-120.png": 9642,
	"./icon-128.png": 2489,
	"./icon-152.png": 7261,
	"./icon-16.png": 4426,
	"./icon-180.png": 3748,
	"./icon-192.png": 4202,
	"./icon-196.png": 4352,
	"./icon-32.png": 3285,
	"./icon-512.png": 6785,
	"./icon-96.png": 4570
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1631;